/* IMPORT */
import channel from './channel.js';
/* MAIN */
const green = (color) => {
    return channel(color, 'g');
};
/* EXPORT */
export default green;
